import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import StorePage from './pages/StorePage'
import DynamicPage from './pages/DynamicPage'
import CheckoutPage from './pages/CheckoutPage'
import OrderSuccessPage from './pages/OrderSuccessPage'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Home page - default landing/store page */}
        <Route path="/" element={<StorePage />} />
        
        {/* Dynamic page routes - for custom pages like /about, /contact, etc */}
        <Route path="/:slug" element={<DynamicPage />} />
        
        {/* Checkout flow */}
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/order-success/:orderId" element={<OrderSuccessPage />} />
        
        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
